import * as tslib_1 from "tslib";
import { BaseSystemConfigurationValues } from "./base.system.configuration.manager";
import * as i0 from "@angular/core";
import * as i1 from "./system.configuration.service";
/**
 Service class for getting system configuration from server after validity checks.
 */
var SystemConfigurationValues = /** @class */ (function (_super) {
    tslib_1.__extends(SystemConfigurationValues, _super);
    function SystemConfigurationValues() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SystemConfigurationValues.prototype, "SelfSchedulingUserIdleTimeout", {
        get: function () {
            return this.getNumber('PP_SelfSchedulingUserIdleTimeout');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "TimeslotReservationEnabled", {
        get: function () {
            return this.getBoolean('TimeslotReservationEnabled');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "PP_ContactInfoMask", {
        get: function () {
            return this.getValidatedString('PP_ContactInfoMask');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "PP_MainContactTelephone", {
        get: function () {
            return this.getValidatedString('PP_MainContactTelephone');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "WeekendIntValues", {
        get: function () {
            return this.getValidatedString('WeekendIntValues');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "PP_ShowWeekNumbersInCalendar", {
        get: function () {
            return this.getBoolean('PP_ShowWeekNumbersInCalendar');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "PP_CalendarFirstDayOfWeek", {
        get: function () {
            return this.getNumber('PP_CalendarFirstDayOfWeek');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "PP_MorningTimeRange", {
        get: function () {
            return this.getValidatedString('PP_MorningTimeRange');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "PP_AfternoonTimeRange", {
        get: function () {
            return this.getValidatedString('PP_AfternoonTimeRange');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "PP_EveningTimeRange", {
        get: function () {
            return this.getValidatedString('PP_EveningTimeRange');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "PP_ShowNewScheduleButton", {
        get: function () {
            return this.getBoolean('PP_ShowNewScheduleButton');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "CanCancelOpCodeKey", {
        get: function () {
            return this.getNumber('CanCancelOpCodeKey');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "CanRescheduleOpCodeKey", {
        get: function () {
            return this.getNumber('CanRescheduleOpCodeKey');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "CanScheduleOpCodeKey", {
        get: function () {
            return this.getNumber('CanScheduleOpCodeKey');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "LockDurationInMinutes", {
        get: function () {
            return this.getNumber('LockDurationInMinutes');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "CanNewOrderAndScheduleOpCodeKey", {
        get: function () {
            return this.getNumber('CanNewOrderAndScheduleOpCodeKey');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "UserPasswordPattern", {
        get: function () {
            return this.getNumber('PP_UserPasswordPattern');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "UserPasswordLength", {
        get: function () {
            return this.getNumber('PP_UserPasswordLength');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "PP_AdditionalInformationAvailable", {
        get: function () {
            return this.getBoolean('PP_AdditionalInformationAvailable');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "PasswordExpirationWarning", {
        get: function () {
            return this.getNumber('PP_PasswordExpirationWarning');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "PP_ScanDocumentMaxSizeKB", {
        get: function () {
            return this.getNumber('PP_ScanDocumentMaxSizeKB');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "PP_ScanDocumentMaxPixelSizeLongEdge", {
        get: function () {
            return this.getNumber('PP_ScanDocumentMaxPixelSizeLongEdge');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "PP_ScanDocumentImageQualityPercentage", {
        get: function () {
            return this.getNumber('PP_ScanDocumentImageQualityPercentage');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "PP_ScanDocumentAttachments", {
        get: function () {
            return this.getValidatedString('PP_ScanDocumentAttachments');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemConfigurationValues.prototype, "PP_ScheduleGapWarningMinutes", {
        get: function () {
            return this.getNumber('PP_ScheduleGapWarningMinutes', 30);
        },
        enumerable: true,
        configurable: true
    });
    SystemConfigurationValues.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SystemConfigurationValues_Factory() { return new SystemConfigurationValues(i0.ɵɵinject(i1.SystemConfigurationService)); }, token: SystemConfigurationValues, providedIn: "root" });
    return SystemConfigurationValues;
}(BaseSystemConfigurationValues));
export { SystemConfigurationValues };
